/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import ActionRequiredViewerPresenter from './ActionRequiredViewerPresenter';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import DTOActionRequiredViewer from './DTOActionRequiredViewer';
import _ from 'lodash';
import { setARData } from '../../../infra/aggregates/actionRequired/actionRequiredSlice';

function ActionRequiredViewerController() {
  const stored_data_in_action_required = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const stored_data_temp_in_action_required = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredDataTemp,
  );

  const actionRequiredEventName = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredEventName,
  );

  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const [arVal, setArVal] = useState('');
  const [allDept, setAllDept] = useState([]);
  const [leaveType, setLeaveType] = useState([]);

  const all_menus = [
    { id: 1, name: 'Leave', eventName: 'leave' },
    {
      id: 2,
      name: 'Leave Advance Encashment',
      eventName: 'leaveAdvanceEncashment',
    },
    { id: 3, name: 'Promotions', eventName: 'promoitons' },
    { id: 4, name: 'Award', eventName: 'award' },
    { id: 7, name: 'Transfer', eventName: 'transfer' },
    { id: 8, name: 'Resignation', eventName: 'resignation' },
    { id: 9, name: 'Termination', eventName: 'termination' },
    { id: 10, name: 'Warning', eventName: 'warning' },
    { id: 11, name: 'Complaint' },
    { id: 12, name: 'Employee Ticket' },
    { id: 13, name: 'Claims' },
    { id: 14, name: 'Overtime' },
    { id: 15, name: 'Payroll Settlement' },
    { id: 16, name: 'Off-Cycle' },
    { id: 17, name: 'Recquiring Paymaent' },
    { id: 18, name: 'Salary Adjustment' },
    { id: 19, name: 'Set Salary' },
    { id: 20, name: 'Government Tax' },
    { id: 21, name: 'FnF' },
    { id: 22, name: 'Letter Request' },
    { id: 23, name: 'Comp Off' },
  ];

  const handleArValue = (val: string) => {
    setArVal(val);
  };

  const callBackSearchFiler = (val: any) => {
    if (val?.length) {
      const txt = val.toLowerCase();
      const res = _.filter(
        stored_data_temp_in_action_required,
        function (e: any) {
          return (
            e?.first_name?.toLowerCase().includes(txt) ||
            e?.last_name?.toLowerCase().includes(txt) ||
            e?.leaveType?.toLowerCase().includes(txt)
          );
        },
      );
      {
        return dispatch(setARData(res));
      }
    } else {
      dispatch(setARData(stored_data_temp_in_action_required));
    }
  };

  const getDeptId = (deptId: any) => {
    if (deptId) {
      const res = _.filter(stored_data_in_action_required, function (e: any) {
        return deptId == e?.department_id;
      });
      {
        return dispatch(setARData(res));
      }
    } else {
      dispatch(setARData(stored_data_temp_in_action_required));
    }
  };

  const [title, setTitle] = useState('Leave Type');

  const getLeaveTypeId = (id: any, label: any) => {
    setTitle(label);
    if (id) {
      const res = _.filter(stored_data_in_action_required, function (e: any) {
        return label == e?.leaveType;
      });
      {
        return dispatch(setARData(res));
      }
    } else {
      dispatch(setARData(stored_data_temp_in_action_required));
    }
  };

  return (
    <>
      <DTOActionRequiredViewer
        setArValFunc={handleArValue}
        setAllLeaveTypes={(leaveType: any) => {
          const leaveTypes: any = _.map(leaveType, (leave: any) => {
            return { id: leave.id, label: leave.name };
          });
          setLeaveType(leaveTypes);
        }}
        setAllDepartments={(allDept: any) => setAllDept(allDept)}
      />
      <ActionRequiredViewerPresenter
        all_menus={all_menus}
        trans={t}
        i18n={i18n}
        arVal={arVal}
        handleSearchFilter={callBackSearchFiler}
        actionRequiredEventName={actionRequiredEventName}
        allDepartments={allDept}
        handleSelectedDeptId={getDeptId}
        leaveType={leaveType}
        handleSelctedLeaveTypeId={getLeaveTypeId}
        title={title}
      />
    </>
  );
}

export default ActionRequiredViewerController;
